import React, { useState, useContext } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Stack, Box, Button } from "@mui/material";
import dayjs from "dayjs";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GeneralContext } from '../../context/GeneralContext';
import { CuestionarioSkeleton } from "./CuestionarioSkeleton";
import '../../styles/CuestionarioHistoricos.css';
import colors from "../../theme/colors";
import { CalificationWithImageAndText } from "./CalificationWithImageAndText";

export const CuestionarioHistoricos = ({ cuestionarios }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setCuestionarioID } = useContext(GeneralContext);

  function bgColorHistorico(cuestionario) {
    if (cuestionario.diferenciaPuntuacion > 0)
      return { backgroundColor: colors.bgDifferenceUp + " !important" }
    else if (cuestionario.diferenciaPuntuacion < 0)
      return { backgroundColor: colors.bgDifferenceDown + " !important" }
    else {
      return { backgroundColor: colors.bgDifferenceMedium + " !important" }
    }
  }

  function historicoIconArrow(cuestionario) {
    if (cuestionario.diferenciaPuntuacion > 0) return <KeyboardArrowUpIcon />
    else if (cuestionario.diferenciaPuntuacion < 0)
      return <KeyboardArrowDownIcon />
    else {
      return <></>
    }
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={1}
      sx={{
        margin: '0',
        width: '100%'
      }}
    >
      {!cuestionarios ? (
        <CuestionarioSkeleton />
      ) : cuestionarios.length === 0 ? (
        <Typography paddingLeft={1} variant="overline">
          {t("misCuestionarios.nofinalizados")}
        </Typography>
      ) : (
        [...cuestionarios].reverse().map((cuestionario, index) => (
          <Grid item xs={12} sm={4} lg={4} key={index}
          sx={{ minWidth: { xs: '100%', sm: '500px' } }}
          >
            <Card style={{ height: "100%" }}>
              <CardContent>
                <Stack
                  direction="column"
                  spacing={2}
                  sx={{
                    border: '0',
                    padding: '0.35rem',
                    fontSize: ' 1rem',
                    textTransform: 'uppercase',
                  }}
                >
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      borderBottom: "1px solid " + colors.underLine,
                      marginTop: "16px",
                      padding: ".625rem",
                    }}
                  >
                    <Grid item>
                      <Typography variant="h5">{t("misCuestionarios.inicio")}</Typography>
                    </Grid>
                    <Grid item>
                      {dayjs(cuestionario.fecha_creacion).format(
                        "DD-MM-YYYY HH:mm"
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      borderBottom: "1px solid " + colors.underLine,
                      padding: ".625rem",
                    }}
                  >
                    <Grid item>
                      <Typography variant={'h5'}>{t("misCuestionarios.fin")}</Typography>
                    </Grid>
                    <Grid item>
                      {dayjs(cuestionario.fecha_fin).format(
                        "DD-MM-YYYY HH:mm"
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      borderBottom: "1px solid " + colors.underLine,
                      padding: ".625rem",
                    }}
                  >
                    <Grid item>
                      <Typography variant="h5">{t("misCuestionarios.calificacion")}</Typography>
                    </Grid>
                    <Grid item>
                      <CalificationWithImageAndText calification={cuestionario.calificacion} width={50} />
                    </Grid>
                  </Grid>
                  {cuestionarios.length > 1 && (
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        padding: ".625rem",
                        marginTop: "0",
                      }}
                    >
                      <Grid item>
                        <Typography variant="h4">{t("misCuestionarios.diferencia")}</Typography>
                      </Grid>
                      <Grid item>
                        <Stack
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          className="card__difference"
                          sx={{
                            maxHeight: '55px',
                            padding: '.8em',
                            background: colors.textMain,
                            boxShadow: colors.bgDarkLight + ' 0px 7px 9px 0px',
                            borderRadius: '1em',
                            backgroundColor: () => bgColorHistorico(cuestionario),
                          }}
                        >
                          <Typography variant="h5">
                            {cuestionario.diferenciaPuntuacion} %
                          </Typography>
                          {historicoIconArrow(cuestionario)}
                        </Stack>
                      </Grid>
                    </Grid>
                  )}
                </Stack>
                <Box sx={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    sx={{ margin: "auto" }}
                    size="large"
                    onClick={() => {
                      setCuestionarioID(cuestionario.id_cuestionario);
                      navigate("/Resultado");
                    }}
                  >
                    {t("misCuestionarios.recomendaciones")}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))
      )}
    </Grid>
  );
};
